module.exports = __webpack_public_path__ + "static/img/8.5e452d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/5/zh/8.png
// module id = YsM9
// module chunks = 0